import '../../css/style.scss'
import {UIWHeaderController} from '../ui_html/header/UIWHeaderController'
import {UISidebarController} from '../ui_html/sidebar/UISidebarController'
import {EntryShared} from '../../../shared/scripts/EntryShared'
import {EntrySingletonPageShared} from '../../EntrySingletonPageShared'
import {UIChampionship25Controller} from '../../../shared/scripts/ui_cc/UIChampionship25Controller'

void init()

async function init() {
    EntryShared.initializeAudio()

    await EntryShared.initializeEntry()

    const headerController = new UIWHeaderController()
    new UISidebarController()

    new UIChampionship25Controller()

    EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    EntryShared.sendPageVisitAnalyticEvent()
}
